import Button from 'components/buttons/Button';

import noResultsIcon from 'assets/events/icons/no-results-icon.svg';

import { useEventsFilters } from '../context/EventsFiltersContext';

export const NoResults = () => {
  const { resetFilters } = useEventsFilters();

  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-gap-[20px] tw-py-[85px] tw-font-jost lg:tw-py-0">
      <img src={noResultsIcon} alt="No results" className="tw-h-[75px] tw-w-[75px]" />
      <p className="tw-text-[18px] tw-font-bold tw-uppercase tw-leading-none tw-text-white">
        No events match your current selection
      </p>
      <p className="tw-mb-[20px] tw-text-[17px] tw-font-medium tw-capitalize tw-leading-none tw-text-white">
        Adjust your selection to see available events
      </p>

      <Button
        text="Restore Defaults"
        size="events"
        color="referral-cta"
        onClick={resetFilters}
        className="tw-w-full tw-max-w-[170px] tw-px-0 tw-capitalize"
      />
    </div>
  );
};
